<div class="flex-direction-column gap-8 padding-15px justify-between height-100">
  <div class="flex-direction-column gap-8">
    <span class="weight-600 font-14" style="margin-bottom: 11px">{{ visualizar ? 'Detalhes Template' : 'Cadastrar Template' }}</span>

    @if (!visualizar) {
      <div>
        <app-escolha-canal-template
          [canalSelecionado]="template.tipo!"
          [bloqueado]="edicao"
          (envioCanal)="receberCanal($event)">
        </app-escolha-canal-template>
      </div>
    }

    @if (!ehSms()) {
      <div>
        <app-menu-superior-template [opcaoSelecionada]="template.categoria!" [bloqueioTotal]="edicao" (opcaoSelecionadaEnvio)="receberOpcaoSeleciodaMenu($event)">
        </app-menu-superior-template>
      </div>
    }

    <div class="flex-direction-column gap-8">
      <app-interacao-marketing
        [template]="template"
        [tipo]="template.tipo!"
        [visualizar]="visualizar"
        [edicao]="edicao"
        (envioTemplate)="template = $event"></app-interacao-marketing>
    </div>
  </div>

  @if (!visualizar) {
    <div class="flex-direction-column gap-5">
      <app-button-padrao width="100%" [label]="salvando ? 'Salvando...' : 'Salvar'" [disabled]="salvando" backgroundColor="var(--verde-padrao)" color="white" (buttonClick)="salvar()"></app-button-padrao>
      <app-button-padrao width="100%" label="Cancelar" [disabled]="salvando" backgroundColor="white" color="var(--vermelho-padrao)" (buttonClick)="cancelar()"
                         borderColor="var(--vermelho-padrao)" borderStyle="solid" borderWidth="1px"></app-button-padrao>
    </div>
  }
</div>
